<section class="main-content wrapper content-padding">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link active-tab"
        >
          CONSEGNE
        </a>
      </label>
    </div>
    <div class="tabs">
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/nuovo-consegne/attiva"
          routerLinkActive="active-tab"
        >
         CONSEGNE ATTIVE
        </a>
      </label>
  
      <label class="tab">
        <a
          class="tab-link"
          routerLink="/nuovo-consegne/archivio"
          routerLinkActive="active-tab"
        >
          NON CONSEGNATE
        </a>
      </label>
    </div>
    <router-outlet></router-outlet>
  </div>
</section>
